import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { LoginModel } from '../models/login-model';
import { ApiProviderService } from './api-provider.service';
import { UserService } from './user.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AuthenticationService {

  token: string;

  constructor(
    public apiProvider: ApiProviderService,
    public userService: UserService,
    private router: Router) {
   }

   login<T extends LoginModel>(loginModel: T): Observable<any> {
    return new Observable(observer => {
      this.apiProvider.login(loginModel).subscribe(
        (response: any) => {
          this.setToken(response.token);
          this.userService.setUser(response.user, response.userRoles);

          if (response.userRoles.includes('Admin')) {
            this.router.navigate(['/admin/coachList']);
          } else if (response.userRoles.includes('Coach')) {
            this.router.navigate(['/coach/dashboard']);
          } else {
            this.router.navigate(['/client/userList']);
          }
          observer.next(response); // Émettre la réponse réussie
          observer.complete();
        },
        (err: any) => {
          console.log(err);
          observer.error(err); // Émettre l'erreur
        }
      );
    });
  }

   setToken(token: string): AuthenticationService{
      localStorage.setItem('token', token);
      return this;
   }

   getToken(): string{
    localStorage.getItem('token');
    return this.token;
   }

}
